<script lang="ts">
  import { createEventDispatcher, getContext } from 'svelte';
  import { Writable } from 'svelte/store';
  import ProductCategoryTile from '../lazy-components/child-helpers/ProductCategoryTile.svelte';
  export let data;
  export let index;

  const activeIndexContext = getContext<Writable<number>>('activeIndex');
  $: isActive = $activeIndexContext === index;
  const dispatcher = createEventDispatcher();

  function onCategoryChange(data) {
    dispatcher('click', data);
  }
</script>

<div class="category-container" class:active={isActive}>
  <ProductCategoryTile
    isCategoryPage={true}
    imageSrc={data?.logoIconUrl}
    categoryName={data.logoName}
    brandUrl={data?.viewAllLinkUrl}
    algoliaUrl={data?.algoliaUrl}
    hitsCount={data?.maxResultCount}
    carouselRuleName={data?.carouselRuleName}
    on:brandCategoryClicked={e => onCategoryChange(e.detail)}
  />
</div>
